export const counties = [
    {
        "name": "Carlow",
        "apartment": false,
        "house": "250000",
        "text": "Carlow County Council"
    },
    {
        "name": "Cavan",
        "apartment": false,
        "house": "250000",
        "text": "Cavan County Council"
    },
    {
        "name": "Clare",
        "apartment": false,
        "house": "300000",
        "text": "Clare County Council"
    },
    {
        "name": "Cork City",
        "apartment": "500000",
        "house": "450000",
        "text": "Cork City Council"
    },
    {
        "name": "Cork County",
        "apartment": false,
        "house": "350000",
        "text": "Cork County Council"
    },
    {
        "name": "Donegal",
        "apartment": false,
        "house": "250000",
        "text": "Donegal"
    },
    {
        "name": "Dublin City",
        "apartment": "500000",
        "house": "450000",
        "text": "Dublin City Council"
    },
    {
        "name": "Dublin South",
        "apartment": "500000",
        "house": "450000",
        "text": "Dublin South County Council"
    },
    {
        "name": "Dun Laoghaire-Rathdown",
        "apartment": "500000",
        "house": "450000",
        "text": "Dun Laoghaire-Rathdown County Council"
    },
    {
        "name": "Fingal",
        "apartment": "500000",
        "house": "450000",
        "text": "Fingal County Council"
    },
    {
        "name": "Galway City",
        "apartment": "450000",
        "house": "400000",
        "text": "Galway City Council"
    },
    {
        "name": "Galway County",
        "apartment": false,
        "house": "350000",
        "text": "Galway County Council"
    },
    {
        "name": "Kerry",
        "apartment": false,
        "house": "300000",
        "text": "Kerry County Council"
    },
    {
        "name": "Kildare",
        "apartment": false,
        "house": "400000",
        "text": "Kildare County Council"
    },
    {
        "name": "Kilkenny",
        "apartment": false,
        "house": "350000",
        "text": "Kilkenny County Council"
    },
    {
        "name": "Laois",
        "apartment": false,
        "house": "300000",
        "text": "Laois County Council"
    },
    {
        "name": "Leitrim",
        "apartment": false,
        "house": "250000",
        "text": "Leitrim County Council"
    },
    {
        "name": "Limerick",
        "apartment": "450000",
        "house": "350000",
        "text": "Limerick City and County Council"
    },
    {
        "name": "Longford",
        "apartment": false,
        "house": "250000",
        "text": "Longford County Council"
    },
    {
        "name": "Louth",
        "apartment": false,
        "house": "300000",
        "text": "Louth County Council"
    },
    {
        "name": "Mayo",
        "apartment": false,
        "house": "300000",
        "text": "Mayo County Council"
    },
    {
        "name": "Meath",
        "apartment": false,
        "house": "350000",
        "text": "Meath County Council"
    },
    {
        "name": "Monaghan",
        "apartment": false,
        "house": "300000",
        "text": "Monaghan County Council"
    },
    {
        "name": "Offaly",
        "apartment": false,
        "house": "300000",
        "text": "Offaly County Council"
    },
    {
        "name": "Roscommon",
        "apartment": false,
        "house": "300000",
        "text": "Roscommon County Council"
    },
    {
        "name": "Sligo",
        "apartment": false,
        "house": "250000",
        "text": "Sligo County Council"
    },
    {
        "name": "Tipperary",
        "apartment": false,
        "house": "250000",
        "text": "Tipperary County Council"
    },
    {
        "name": "Waterford",
        "apartment": "450000",
        "house": "350000",
        "text": "Waterford City and County Council"
    },
    {
        "name": "Westmeath",
        "apartment": false,
        "house": "350000",
        "text": "Westmeath County Council"
    },
    {
        "name": "Wexford",
        "apartment": false,
        "house": "300000",
        "text": "Wexford County Council"
    },
    {
        "name": "Wicklow",
        "apartment": false,
        "house": "450000",
        "text": "Wicklow County Council"
    }
]